import { render } from "./RigaOrdineStorico.vue?vue&type=template&id=d6a13ffc"
import script from "./RigaOrdineStorico.vue?vue&type=script&lang=js"
export * from "./RigaOrdineStorico.vue?vue&type=script&lang=js"

import "./RigaOrdineStorico.vue?vue&type=style&index=0&id=d6a13ffc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__